

import { computed, ref, toRaw } from 'vue'
import { uploadFileToOss } from '@/utils/oss'
import { UploadOutlined, QuestionCircleOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { supportedFormats, CoursewareType } from '../config.js'

export default {
  components: {
    UploadOutlined,
    QuestionCircleOutlined
  },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  },
  setup (props, { emit }) {
    // 可见度
    const visibleCompu = computed(() => props.visible)

    const formRef = ref()
    const formData = ref({})

    const uploadLoading = ref(false)

    const loadingCompu = computed(() => props.loading)
    // 上传相关
    const fileName = ref('')
    // 当前文件
    const currentFile = ref(null)
    // 进度条相关
    const uploadPrecent = ref(0)
    const uploadStatus = ref('normal')

    const handleBeforeUpload = (file) => {
      currentFile.value = file
      fileName.value = file.name
      uploadPrecent.value = 0
      uploadStatus.value = 'normal'
      return false
    }

    const supportedFormatsString = Object.values(supportedFormats).flat().map(x => '.' + x).join(',')

    const onPrecentChange = (precent) => {
      uploadPrecent.value = precent
    }

    const handleUpload = async () => {
      if (currentFile.value) {
        try {
          uploadLoading.value = true
          uploadStatus.value = 'normal'
          const fileType = currentFile.value.type.substring(0, currentFile.value.type.lastIndexOf('/'))
          const suffix = currentFile.value.name.slice(currentFile.value.name.lastIndexOf('.') + 1)
          console.log(currentFile, suffix)
          // 兼容flash文件的格式
          if (
            (Object.values(CoursewareType).includes(fileType) && Object.values(supportedFormats).flat().includes(suffix)) ||
            (fileType === 'application' && Object.values(supportedFormats).flat().includes(suffix) && currentFile.value.type === 'application/x-shockwave-flash')
          ) {
            const data = await uploadFileToOss(currentFile.value, true, onPrecentChange)
            formData.value = {
              ...toRaw(formData.value),
              url: data.url,
              md5: data.md5,
              size: data.size,
              type: fileType === 'application' ? suffix : fileType
            }
            uploadStatus.value = 'success'
            message.success('上传成功')
          } else {
            message.error('不支持该文件格式')
          }
          uploadLoading.value = false
        } catch (error) {
          uploadLoading.value = false
          console.log(error)
          uploadStatus.value = 'exception'
          message.error('上传失败，请重试')
        }
      }
    }

    const handleCleanAll = () => {
      currentFile.value = null
      fileName.value = ''
      uploadPrecent.value = 0
      uploadStatus.value = 'normal'
      uploadLoading.value = false
      formData.value = {
        ...toRaw(formData.value),
        url: undefined,
        md5: undefined,
        size: undefined,
        type: undefined
      }
    }

    const handleSubmit = () => {
      formRef.value.validate().then(() => {
        if (formData.value.url === undefined) {
          message.error('请选择要上传的文件')
          return
        }
        emit('onOk', formData.value)
      })
    }

    const handleCancel = () => {
      emit('onCancel')
    }

    return {
      visibleCompu,
      loadingCompu,
      formRef,
      formData,
      currentFile,
      uploadLoading,
      uploadPrecent,
      uploadStatus,
      fileName,
      supportedFormatsString,
      supportedFormats,
      handleSubmit,
      handleCancel,
      handleBeforeUpload,
      handleUpload,
      handleCleanAll
    }
  }
}
